import { render, staticRenderFns } from "./vacation-administrator.view.vue?vue&type=template&id=7813c3e0&scoped=true&"
import script from "./vacation-administrator.view.vue?vue&type=script&lang=ts&"
export * from "./vacation-administrator.view.vue?vue&type=script&lang=ts&"
import style0 from "./vacation-administrator.view.vue?vue&type=style&index=0&id=7813c3e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813c3e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VDataTable,VIcon,VRow})
